// extracted by mini-css-extract-plugin
export default {"game":"style_game__6wWbg"};